import { SEATING_PREFERENCE_OPTIONS } from './constants';
import { getAvailableDeckOptions } from './cabin';
export const getSegment = function (segments, activeSegment) {
  if (segments === void 0) {
    segments = [];
  }
  const hasSegments = segments.some(_ref => {
    let {
      segmentIndex
    } = _ref;
    return Number.isInteger(segmentIndex);
  });
  if (!hasSegments) {
    return null;
  }
  return segments.find(_ref2 => {
    let {
      boundSegmentIndex
    } = _ref2;
    return boundSegmentIndex === activeSegment;
  });
};
const isSegmentAvailable = segment => {
  const isSeatPreferenceAvailable = segment.__typename && (segment.__typename === SEATING_PREFERENCE_OPTIONS.SELL_SEATING_BESIDE || segment.__typename === SEATING_PREFERENCE_OPTIONS.SELL_SEATING_PREFERENCE);
  return Boolean(segment.mainDeck || segment.lowerDeck || segment.upperDeck || isSeatPreferenceAvailable);
};
export const flatBounds = function (bounds) {
  if (bounds === void 0) {
    bounds = [];
  }
  return bounds.flatMap(segments => segments.sellSeatMapSegments.map(segment => ({
    ...segment,
    boundIndex: segments.boundIndex,
    boundName: segments.boundName,
    boundSegmentId: [segments.boundIndex, segment.boundSegmentIndex],
    isAvailable: isSegmentAvailable(segment)
  })));
};
export const getNextSegment = function (segments, activeSegment) {
  if (activeSegment === void 0) {
    activeSegment = null;
  }
  if (!Array.isArray(segments) || segments.length === 0) {
    return null;
  }
  const activeIndex = segments.findIndex(segment => typeof segment.boundSegmentIndex === 'string' && segment.boundSegmentIndex === activeSegment);
  const nextSegment = segments.find((_, index) => index > activeIndex);
  return nextSegment || null;
};
export const findIndexOfSegment = (segments, boundSegmentIndex) => segments.findIndex(b => b.boundSegmentIndex === boundSegmentIndex);
export const findNextAvailableSegment = function (segments, activeSegmentIndex) {
  if (segments === void 0) {
    segments = [];
  }
  const activeIndex = findIndexOfSegment(segments, activeSegmentIndex);
  const succeedingSegments = segments.slice(activeIndex + 1);
  const [nextSegment] = succeedingSegments;
  return nextSegment;
};
export const findPreviousAvailableSegment = function (segments, activeSegmentIndex) {
  if (segments === void 0) {
    segments = [];
  }
  const activeIndex = findIndexOfSegment(segments, activeSegmentIndex);
  const precedingSegments = segments.slice(0, activeIndex);
  const previousSegment = precedingSegments[precedingSegments.length - 1];
  return previousSegment;
};
export const isLastAvailableSegment = (segments, boundSegmentIndex) => {
  const last = segments[segments.length - 1];
  return last.boundSegmentIndex === boundSegmentIndex;
};
export const getSeatCharacteristics = function (segments, activeBoundSegmentIndex) {
  var _segment$bestPriceCha;
  if (segments === void 0) {
    segments = [];
  }
  const hasSegments = segments.some(_ref3 => {
    let {
      segmentIndex
    } = _ref3;
    return Number.isInteger(segmentIndex);
  });
  if (!hasSegments) {
    return [];
  }
  const segment = segments.find(_ref4 => {
    let {
      boundSegmentIndex
    } = _ref4;
    return boundSegmentIndex === activeBoundSegmentIndex;
  });
  const characteristics = (_segment$bestPriceCha = segment === null || segment === void 0 ? void 0 : segment.bestPriceCharacteristics) !== null && _segment$bestPriceCha !== void 0 ? _segment$bestPriceCha : [];
  return characteristics.filter(c => Boolean(c));
};
export const isFirstAvailableSegment = (segments, boundSegmentIndex) => {
  const first = segments[0];
  return (first === null || first === void 0 ? void 0 : first.boundSegmentIndex) === boundSegmentIndex;
};
export const getSegmentTravelers = (travelers, flattenedBounds, segmentIndex) => {
  if (!Array.isArray(travelers) || !Array.isArray(flattenedBounds)) {
    return [];
  }
  const segment = flattenedBounds.find(bound => bound.boundSegmentIndex === segmentIndex);
  if (!segment || !segment.travelerIds) {
    return [];
  }
  const travelerIdsSet = new Set(segment.travelerIds.map(id => Number(id)));
  const filteredTravelers = travelers.filter(_ref5 => {
    let {
      id
    } = _ref5;
    return travelerIdsSet.has(Number(id));
  });
  return filteredTravelers;
};
export const getActiveDeck = options => {
  var _options$find;
  return (_options$find = options.find(deck => deck.value === 'mainDeck')) !== null && _options$find !== void 0 ? _options$find : options[0];
};
export const getAvailableDeckOptionsForSegment = (segments, boundSegmentIndex, upperDeckLabel, mainDeckLabel, lowerDeckLabel) => {
  const currentSegment = segments.find(_ref6 => {
    let {
      boundSegmentIndex: index
    } = _ref6;
    return index === boundSegmentIndex;
  });
  if (!currentSegment) {
    return [];
  }
  return getAvailableDeckOptions(currentSegment, upperDeckLabel, mainDeckLabel, lowerDeckLabel);
};
export const getFirstAvailableSegmentActiveDeck = (segments, firstAvailableSegmentIndex, upperDeckLabel, mainDeckLabel, lowerDeckLabel) => {
  const availableOptions = getAvailableDeckOptionsForSegment(segments, firstAvailableSegmentIndex, upperDeckLabel, mainDeckLabel, lowerDeckLabel);
  return getActiveDeck(availableOptions);
};
const getOrderedTravelers = (travelers, currentTravelerId) => {
  const index = travelers.findIndex(traveler => traveler.id === currentTravelerId);
  return index === -1 ? travelers : [...travelers.slice(index), ...travelers.slice(0, index)];
};
export const getIdOfFirstUnselectedTraveler = (travelers, selection, currentTravelerId) => {
  if (!Array.isArray(travelers) || travelers.length === 0) {
    return null;
  }
  if (!selection) {
    return travelers[0].id;
  }
  const orderedTravelers = getOrderedTravelers(travelers, currentTravelerId);
  const nextTraveler = orderedTravelers.find(traveler => selection.every(s => s.id !== traveler.id));
  return nextTraveler ? nextTraveler.id : null;
};
//# sourceMappingURL=seatMapContentUtils.js.map